import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    name: "/loginNew",
    component: () => import("../views/loginNew.vue"),
  },
  {
    path: "/register",
    name: "/register",
    component: () => import("../views/register.vue"),
  },
  {
    path: "/daohang",
    name: "/daohang",
    component: () => import("../views/daohang.vue"),
    children: [
      {
        path: "/page01",
        name: "/page01",
        component: () => import("../views/page01.vue"),
        meta: { keepAlive:true, }
      },
      {
        path: "/page02",
        name: "/page02",
        component: () => import("../views/page02.vue"),
      },
      {
        path: "/page03/",
        name: "/page03",
        component: () => import("../views/page03.vue"),
      },
      {
        path: "/page04",
        name: "/page04",
        component: () => import("../views/page04.vue"),
      },
      {
        path: "/page05",
        name: "/page05",
        component: () => import("../views/page05.vue"),
      },
      {
        path: "/page06",
        name: "/page06",
        component: () => import("../views/page06.vue"),
      },
      {
        path: "/page07",
        name: "/page07",
        component: () => import("../views/page07.vue"),
      },
      {
        path: "/page08",
        name: "/page08",
        component: () => import("../views/page08.vue"),
      },
      {
        path: "/page09",
        name: "/page09",
        component: () => import("../views/page09.vue"),
      },
      {
        path: "/page10",
        name: "/page10",
        component: () => import("../views/page10.vue"),
        children:[
          {
            path: "/page11",
            name: "/page11",
            component: () => import("../views/page11.vue"),
          },{
            path: "/page12",
            name: "/page12",
            component: () => import("../views/page12.vue"),
          },{
            path: "/page13",
            name: "/page13",
            component: () => import("../views/page13.vue"),
          },
        ]
      },
      // {
      //   path: "/page14/",
      //   name: "/page14",
      //   component: () => import("../views/page14.vue"),
      // },
      {
        path: "/copyrightRegistration",
        name: "/copyrightRegistration",
        component: () => import("../views/copyrightRegistration.vue"),
      },
      {
        path: "/home",
        name: "/home",
        component: () => import("../views/home.vue"),
      },
      {
        path: "/underDevelopment",
        name: "/underDevelopment",
        component: () => import("../views/underDevelopment.vue"),
      },
    ],
  },
  // {
  //   path: "/page10",
  //   name: "/page10",
  //   component: () => import("../views/page10.vue"),
  //   children: [
  //     {
  //       path: "/page11",
  //       name: "/page11",
  //       component: () => import("../views/page11.vue"),
  //     },{
  //       path: "/page12",
  //       name: "/page12",
  //       component: () => import("../views/page12.vue"),
  //     },{
  //       path: "/page13",
  //       name: "/page13",
  //       component: () => import("../views/page13.vue"),
  //     },
  //   ]
  // }
];

const router = new VueRouter({
  routes,
});

export default router;
